import React, { useCallback, useMemo } from 'react';
import { mdiContentSaveEditOutline, mdiLockOutline } from '@mdi/js';

import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import ProfilePage54origins from '../54origins/components/ProfilePage54origins';
import ProfileEditFormComponent from './ProfileEditFormComponent';
import ChangePasswordComponent from './ChangePasswordComponent';
import MyPermissionsSection from '../profile/components/MyPermissionsSection';

import { ProfileConstants } from '../profile/constants';

import useCustomState from '../hooks/useCustomState';
import AntButtonWithMDI from './AntButtonWithMDI';
import { capitalizeAndTranslateMsg } from '../mainUtils';
import { getMeIsRootOrAdmin } from '../profile/selectors';

const profileTypes = [
  ProfileConstants.GET_PROFILE_INFO_REQUEST,
  ProfileConstants.GET_PROFILE_INFO_SUCCESS,
  ProfileConstants.GET_PROFILE_INFO_FAILURE,
];

function AuthProfileWrapper() {
  const {
    toggle: editToggle,
    updateTime,
    setToggle: setEditToggle,
    changeState,
  } = useCustomState();

  const { toggle: passwordToggle, setToggle: setPasswordToggle } = useCustomState();

  const meIsRootOrAdmin = useSelector(getMeIsRootOrAdmin);

  const updateActorCallback = useCallback(() => {
    changeState({ updateTime: new Date().getTime() });
  }, []);

  const editBtn = (
    <div className="flex items-center ml-auto">
      {meIsRootOrAdmin ? (
        <AntButtonWithMDI
          type="primary"
          onClick={setEditToggle}
          iconClassName="mb-1 mr-1"
          pathForMdi={mdiContentSaveEditOutline}
          label={capitalizeAndTranslateMsg('54origins.verb.edit', 'Edit')}
        />
      ) : (
        <Tooltip title="Only for Root or Admin">
          <span>
            <AntButtonWithMDI
              disabled
              type="primary"
              onClick={setEditToggle}
              iconClassName="mb-1 mr-1"
              pathForMdi={mdiContentSaveEditOutline}
              label={capitalizeAndTranslateMsg('54origins.verb.edit', 'Edit')}
            />
          </span>
        </Tooltip>
      )}
      <AntButtonWithMDI
        className="ml-2 button-secondary-outlined"
        onClick={setPasswordToggle}
        iconClassName="mb-1 mr-1"
        pathForMdi={mdiLockOutline}
        label={capitalizeAndTranslateMsg('auth.buttons.change_password', 'change password')}
      />
    </div>
  );

  const editComponent = useMemo(() => {
    if (editToggle) {
      return (
        <ProfileEditFormComponent
          setToggle={setEditToggle}
          updateActorCallback={updateActorCallback}
        />
      );
    }
    if (passwordToggle) {
      return <ChangePasswordComponent onCancel={setPasswordToggle} />;
    }
    return null;
  }, [editToggle, passwordToggle]);

  return (
    <>
      <ProfilePage54origins
        updateFromOuterComponent={updateTime}
        typesForRequest={profileTypes}
        editBtn={editBtn}
        editComponent={editComponent}
      />
      <MyPermissionsSection />
    </>
  );
}

export default AuthProfileWrapper;
